// Valores por defecto de catálogos editables desde Configuración (Productos, Inventario, Objetivos SMART).
// Se usan como "semilla" la primera vez (antes de que el admin guarde nada en
// configuracion_ticket) y como respaldo si la clave llega vacía o corrupta.
//
// 'ventas', 'comandas' y 'clientes' están marcadas sistema:true porque
// backend/src/controllers/objetivosController.js calcula su valor_actual
// automáticamente comparando obj.categoria === 'ventas' | 'comandas' | 'clientes'
// (string literal). Cambiar esas 3 claves rompería el auto-cálculo, por eso
// la UI no permite borrarlas ni renombrar su value — solo su label/color.
export type CategoriaObjetivo = { value: string; label: string; color: string; sistema: boolean };

export const CATEGORIAS_OBJETIVOS_DEFAULT: CategoriaObjetivo[] = [
  { value: 'ventas',     label: '💰 Ventas',     color: 'var(--ok)', sistema: true },
  { value: 'comandas',   label: '🧾 Comandas',   color: 'var(--info)', sistema: true },
  { value: 'clientes',   label: '👥 Clientes',   color: '#7E22CE', sistema: true },
  { value: 'inventario', label: '📦 Inventario', color: 'var(--warn)', sistema: false },
  { value: 'personal',   label: '🙋 Personal',   color: '#BE185D', sistema: false },
  { value: 'otro',       label: '🎯 Otro',        color: 'var(--muted)', sistema: false },
];

export const UNIDADES_OBJETIVOS_DEFAULT = ['$', '%', 'comandas', 'personas', 'minutos', 'kg'];
export const UNIDADES_INSUMOS_DEFAULT = ['pieza', 'kg', 'gramo', 'litro', 'ml', 'porción', 'taza', 'lata', 'bolsa', 'caja'];
export const UNIDADES_PRODUCTOS_DEFAULT = ['PIEZA', 'PORCIÓN', 'ORDEN', 'VASO', 'TAZA', 'ACTIVIDAD'];

export function parseCategorias(json: string | undefined): CategoriaObjetivo[] {
  if (!json) return CATEGORIAS_OBJETIVOS_DEFAULT;
  try {
    const arr = JSON.parse(json);
    return Array.isArray(arr) && arr.length > 0 ? arr : CATEGORIAS_OBJETIVOS_DEFAULT;
  } catch { return CATEGORIAS_OBJETIVOS_DEFAULT; }
}

export function parseCsv(csv: string | undefined, fallback: string[]): string[] {
  if (!csv) return fallback;
  const lista = csv.split(',').map(s => s.trim()).filter(Boolean);
  return lista.length > 0 ? lista : fallback;
}
